<template>
  <SocialMentionCard
    v-bind="{ ...$props, ...$attrs }"
    class="pointer youtube"
    :icon="socialIcon(mention.type)"
    :list-title="listTitle"
    @click="$emit('click', $event)"
    @mention-removed="removeMention"
    @mention-selected="$emit('mention-selected', $event)"
  >
    <template #header>
      <span class="title">
        <strong class="ellipsis-2-lines">
          {{ mention.title }}
        </strong>
      </span>

      <span class="text-blue-grey subtitle">
        <SocialMentionCardFollowerCount
          v-if="mention.author_follower_count"
          display-separator
          :follower-count="mention.author_follower_count"
        />

        <AuthorWidget
          v-if="mention.author"
          :disable-click="options.disableAuthorClick"
          :mention="mention"
          no-spacer
        />
        <strong> · </strong>
        <TimeAgo
          class="text-blue-grey self-start"
          :date="mention.timestamp"
        />
      </span>
    </template>

    <slot />

    <template #attachments>
      <SocialMentionCardAttachedMediaAsset
        :duration="mention.duration"
        :thumbnail="mention.thumbnail_url"
        type="video"
        :url="mention.public_link"
      />
    </template>

    <template #engagement-items>
      <SocialMentionEngagementItem
        icon="views"
        :model-value="mention.view_count"
      />

      <SocialMentionEngagementItem
        icon="youtube_like"
        :model-value="mention.like_count"
      />

      <SocialMentionEngagementItem
        icon="comments"
        :model-value="mention.comment_count"
      />
    </template>
  </SocialMentionCard>
</template>

<script>
import AuthorWidget from "shared/components/AuthorWidget.vue";
import { propsExcept, SocialMentionCard } from "shared/components/MentionCard";
import SocialMentionCardAttachedMediaAsset from "shared/components/SocialMentionCardAttachedMediaAsset.vue";
import SocialMentionCardFollowerCount from "shared/components/SocialMentionCardFollowerCount.vue";
import SocialMentionEngagementItem from "shared/components/SocialMentionEngagementItem.vue";
import { socialIcon } from "shared/helpers/media";

export default {
  name: "SocialMentionCardYoutubeVideo",
  components: {
    SocialMentionCard,
    AuthorWidget,
    SocialMentionCardAttachedMediaAsset,
    SocialMentionEngagementItem,
    SocialMentionCardFollowerCount,
  },
  props: {
    ...propsExcept(["listTitle"]),
  },
  emits: ["click", "mention-selected", "mention-removed"],
  computed: {
    listTitle() {
      return this.mention.author;
    },
  },
  methods: {
    socialIcon,
    removeMention(mention) {
      this.$emit("mention-removed", mention);
    },
  },
};
</script>
